<template>
	<div id="wrapper">
		<SidebarView :loan="true" :loanTransaction="true" :loan-visible="true" />
		<div class="d-flex flex-column" id="content-wrapper">
			<div id="content">
				<TopbarView />
				<div class="mx-3">
					<div class="card card-shape home-box">
						<div class="card-header">
							<div class="d-flex justify-content-between align-items-center">
								<div>
									<h6 class="m-0 fw-bold text-green">
										All Disbursment / Repayments
									</h6>
								</div>
								<div>
									<b-link @click="exportToExcel" class="fw-semibold ms-2 akkurate-green">
										<font-awesome-icon :icon="['fas', 'file-excel']" /></b-link>
								</div>
							</div>
						</div>
						<div class="card-body default_bg" style="border-bottom: 1px solid rgb(1, 134, 115)">
							<div class="home-box border border-success py-1 bg-white">
								<div class="my-1 row text-center">
									<div class="col-12" v-if="this.form.users.length > 0">
										<p class="mb-0 my-1 small">
											Selected Users
											<span class="fw-bold">{{
												coa_name
											}}</span>
										</p>
									</div>
									<div class="col-6 col-md-2">
										<p class="mb-0 small">
											<font-awesome-icon :icon="['fas', 'circle']" class="akkurate-green" />
											Total Disbursed <br /><span class="fw-bold">{{
												displayNumber(
													total_loan_disbursed
												)
											}}</span>
										</p>
									</div>
									<div class="col-6 col-md-2">
										<p class="mb-0 small">
											<font-awesome-icon :icon="['fas', 'circle']" class="akkurate-danger" />
											Total Repayments <br /><span class="fw-bold">{{
												displayNumber(
													total_loan_repayment
												)
											}}</span>
										</p>
									</div>

									<div class="col-6 col-md-3">
										<p class="mb-0 small">
											<font-awesome-icon :icon="['fas', 'circle']"
												class="akkurate-blue-text rounded-circle" />
											Principal Balance <br /><span class="fw-bold">{{
												displayNumber(
													total_loan_principal_balance
												)
											}}</span>
										</p>
									</div>

									<div class="col-6 col-md-2">
										<p class="mb-0 small">
											<font-awesome-icon :icon="['fas', 'circle']"
												class="akkurate-grey rounded-circle" />
											Principal Paid <br /><span class="fw-bold">{{
												displayNumber(
													total_principal_paid
												)
											}}</span>
										</p>
									</div>
									<div class="col-6 col-md-3">
										<p class="mb-0 small">
											<font-awesome-icon :icon="['fas', 'circle']"
												class="akkurate-warning-text rounded-circle" />
											Total Adjusted Principal <br /><span class="fw-bold">{{
												displayNumber(
													total_adjustment_repayment
												)
											}}</span>
										</p>
									</div>

									<div class="col-12">
										<hr />
									</div>

									<div class="col-6 col-md-2">
										<p class="mb-0 small">
											<font-awesome-icon :icon="['fas', 'circle']" class="akkurate-green" />
											Total Expected Interest <br /><span class="fw-bold">{{
												displayNumber(
													total_expected_interest
												)
											}}</span>
										</p>
									</div>

									<div class="col-6 col-md-2">
										<p class="mb-0 small">
											<font-awesome-icon :icon="['fas', 'circle']"
												class="akkurate-danger rounded-circle" />
											Loan Balance <br /><span class="fw-bold">{{
												displayNumber(
													total_loan_balance
												)
											}}</span>
										</p>
									</div>
									<div class="col-6 col-md-3">
										<p class="mb-0 small">
											<font-awesome-icon :icon="['fas', 'circle']"
												class="akkurate-blue-text rounded-circle" />
											Interest Balance <br /><span class="fw-bold">{{
												displayNumber(
													total_loan_interest_balance
												)
											}}</span>
										</p>
									</div>

									<div class="col-6 col-md-2">
										<p class="mb-0 small"><font-awesome-icon :icon="['fas', 'circle']"
												class="akkurate-grey rounded-circle" />
											Interest Paid <br /><span class="fw-bold">{{
												displayNumber(total_interest_paid) }}</span></p>
									</div>
									<div class="col-6 col-md-3">
										<p class="mb-0 small"><font-awesome-icon :icon="['fas', 'circle']"
												class="akkurate-warning-text rounded-circle" />
											Actual Disbursed <br /><span class="fw-bold">{{
												displayNumber(total_actual_disbursed) }}</span></p>
									</div>
								</div>
								<hr class="m-0" />
								<div class="card-body pt-0">
									<form @submit.prevent="submitFormFilters()">
										<div class="row">
											<div class="col-12 col-md-6">
												<label class="akkurate-dark small" for="search">Search</label>
												<b-form-group id="search" label-for="search" class="akkurate-dark">
													<b-form-input id="search" class="mt-2 field-container fields"
														type="text" v-model="form.search"
														placeholder="Search by name, code, A/C, phone ...">
													</b-form-input>
												</b-form-group>
											</div>
											<div class="col-12 col-md-2">
												<label class="akkurate-dark small" for="loan_number">Loan Number</label>
												<b-form-group id="loan_number" label-for="loan_number"
													class="akkurate-dark">
													<b-form-input id="loan_number" class="mt-2 field-container fields"
														type="text" v-model="form.loan_number"
														placeholder="Enter loan number ...">
													</b-form-input>
												</b-form-group>
											</div>
											<div class="col">
												<label class="akkurate-dark small" for="search">Product</label>
												<b-form-group id="search" label-for="search" class="akkurate-dark">
													<multiselect class="mt-2 field-container" label="name"
														v-model="form.scheme" :options="schemes_option"
														placeholder="Select status" selectLabel="" deselectLabel="">
													</multiselect>
												</b-form-group>
											</div>
											<div
												class="d-grid gap-2 col-md-2 mt-auto d-flex align-content-center justify-content-center">
												<b-button type="submit"
													class="akkurate-green-btn akkurate-auth-size w-100"><i
														class="fas fa-search me-2"></i>Search</b-button>
												<b-button size="sm" v-b-modal.modal-transaction
													title="show more filters" class="ms-2">
													<i class="fas fa-bars akkurate-small"></i>
												</b-button>
											</div>
										</div>
									</form>
								</div>
								<b-modal size="lg" id="modal-transaction" @ok="handleOk">
									<template #modal-title>
										<h6 class="fw-bold mb-0 akkurate-green">Filter</h6>
									</template>
									<loan-trans-filter :form="form" :users="users"
										:branch_option="branch_option"></loan-trans-filter>
									<template #modal-footer="{ ok }">

										<div class="w-100">
											<!-- Emulate built in modal footer ok and cancel button actions -->
											<b-button @click="$bvModal.hide('modal-transaction')" type="button"
												class="akkurate-grey-btn border-0 btn-size ms-2 float-right"><span
													class="small"><font-awesome-icon class="me-2"
														:icon="['fas', 'close']" />Cancel
												</span></b-button>
											<b-button @click="ok()" type="submit" :disabled="isSaving"
												class="akkurate-green-btn btn-size float-right border-0"><span
													class="small"><font-awesome-icon class="me-2"
														:icon="['fas', 'search']" />Search</span></b-button>
										</div>
									</template>
								</b-modal>
							</div>
						</div>
						<div class="card-body pt-0 px-0">
							<div class="table_text_size">
								<b-table striped bordered responsive id="allAccountTable" :busy.sync="isLoading"
									:items="rows" :fields="trans_columns" :tbody-tr-class="rowClass" show-empty>
									<template #empty="scope">
										<h4 class="text-center small mt-3">{{ scope.emptyText }}</h4>
									</template>
									<template #table-busy>
										<div class="text-center text-danger my-2">
											<b-spinner class="align-middle"></b-spinner>
											<strong>Loading...</strong>
										</div>
									</template>
									<template #cell(index)="data">
										{{ data.index + 1 }}
									</template>
									<!-- A custom formatted column -->
									<template #cell(user)="data">
										{{ data.item.created_user?.first_name }} {{ data.item.created_user?.surname }}
									</template>
									<template #cell(full_name)="data">
										{{ data.item.customer?.last_name }} {{ data.item.customer?.first_name }}
									</template>
									<template #cell(trans_status)="data">
										<span :class="statusBadge(data.item?.trans_status)">{{ data.item?.trans_status
										}}</span>
									</template>
									<template #cell(loan_principal_amount)="data">
										<span>{{ displayNumber(data.item.loan?.principal_amount) }}</span>
									</template>
									<template #cell(loan_expected_interest)="data">
										<span>{{ displayNumber(data.item.loan?.expected_interest) }}</span>
									</template>
									<template #cell(trans_amount)="data">
										<span>{{ displayNumber(data.item.trans_amount) }}</span>
									</template>
									<template #cell(principal)="data">
										<span>{{ displayNumber(data.item?.principal) }}</span>
									</template>
									<template #cell(principal_paid)="data">
										<span>{{ displayNumber(data.item?.principal_paid) }}</span>
									</template>
									<template #cell(interest)="data">
										<span>{{ displayNumber(data.item?.interest) }}</span>
									</template>
									<template #cell(interest_paid)="data">
										<span>{{ displayNumber(data.item?.interest_paid) }}</span>
									</template>
									<template #cell(principal_balance)="data">
										<span>{{ displayNumber(data.item?.principal_balance) }}</span>
									</template>
									<template #cell(interest_balance)="data">
										<span>{{ displayNumber(data.item?.interest_balance) }}</span>
									</template>
									<template #cell(references)="data">
										<b-link v-b-tooltip.hover="{ variant: 'info' }"
											title="Click to view ledger entries"
											class="text-decoration-none akkurate-green"
											:href="`/chart-of-accounts/transactions?reference=${getRef(data.item)}`">
											{{ getRef(data.item) }}
										</b-link>
									</template>
									<template #cell(actions)="data">
										<span class="d-flex">
											<loan-transaction-view v-if="data.item.deleted_at == null"
												:key="data.item.id + 'View'" :data="data.item"
												:transaction="'View'"></loan-transaction-view>

											<a title="Edit" v-if="
												data.item.deleted_at == null
											" class="btn btn-sm text-white akkurate-blue border-0 custom-pointer" @click="
												showLoanTransEditModal(
													data.item
												)
												">
												<span class="akkurate-small"><font-awesome-icon
														:icon="['fas', 'edit']" /></span>
											</a>

											<div class="dropdown no-arrow d-inline">
												<a title="More Action"
													class="btn btn-sm text-white akkurate-gray-btn custom-pointer border-0 dropdown-toggle"
													id="dropdownMenu" data-bs-toggle="dropdown" aria-haspopup="true"
													aria-expanded="false">
													<span class="akkurate-small">
														<font-awesome-icon :icon="[
															'fas',
															'money-bill-transfer',
														]" />
													</span>
												</a>
												<div class="dropdown-menu shadow animated--fade-in"
													aria-labelledby="dropdownMenu">
													<div class="dropdown-header">
														More Actions
													</div>
													<button class="custom-dropdown-item icon-color"
														@click="transferModal(data.item?.id)">
														Transfer
														<i class="icon-color fas fa-share"></i>
													</button>
													<button v-if="data.item?.trans_status == 'COMPLETED'"
														class="custom-dropdown-item icon-color"
														@click="printOut(data.item)">
														Print
														<font-awesome-icon :icon="[
															'fas',
															'book',
														]" />
													</button>
												</div>
											</div>
											<!-- <a title="Transfer" v-if="data.item.deleted_at == null"
                                                    class="btn btn-sm akkurate-gray-btn  text-white border-0 custom-pointer"
                                                    @click="showSavingTransfertModal(data.item)" variant="primary">
                                                    <span class="akkurate-small"><font-awesome-icon
                                                            :icon="['fas', 'forward']" /></span>
                                                </a> -->

											<!-- <div title="Print" class="dropdown no-arrow" v-if="
												data.item.deleted_at == null
											">
												<a title="Print"
													class="btn btn-sm akkurate-gray-btn text-white dropdown-toggle"
													id="dropdownMenu" data-bs-toggle="dropdown" aria-haspopup="true"
													aria-expanded="false">
													<span class="akkurate-small">
														<font-awesome-icon :icon="[
															'fas',
															'book',
														]" />
													</span>
												</a>
												<div class="dropdown-menu shadow animated--fade-in"
													aria-labelledby="dropdownMenu">
													<div class="dropdown-header">
														Printout
													</div>
													<button v-if="
														data.item.trans_status == 'COMPLETED'" class="dropdown-item" @click="
															printReceipt(data.item)">
														Print receipts
													</button>
													<button @click="
														chequePrintout(
															data.item
														)
														" v-if="
															data.item
																.transaction_mode ==
															'Cheque' &&
															data.item
																.transaction_type ==
															'Withdrawal'
														" class="dropdown-item">
														Cheque print
													</button>
													<button @click="
														chequeTemplate(
															data.item
														)
														" v-if="
															data.item
																.transaction_mode ==
															'Cheque' &&
															data.item
																.transaction_type ==
															'Withdrawal'
														" class="dropdown-item">
														Cheque voucher
													</button>
												</div>
											</div> -->
											<span v-if="
												delete_trans && data.item.deleted_at == null">
												<a v-if="data.item.trans_status == 'PENDING'" title="Delete"
													class="btn btn-sm akkurate-danger-btn text-white"
													@click="deleteTransaction(data.item)">
													<span class="akkurate-small">
														<font-awesome-icon :icon="[
															'fas',
															'trash',
														]" />
													</span>
												</a>
											</span>
											<span v-else-if="
												restore_trans &&
												data.item.deleted_at != null
											">
												<a title="Restore"
													class="btn btn-sm akkurate-green-btn text-white border-0 custom-pointer"
													@click="
														restoreTransaction(
															data.item
														)
														" variant="primary">
													<span class="akkurate-small"><font-awesome-icon :icon="[
														'fas',
														'arrow-rotate-left',
													]" /></span>
												</a>
											</span>
										</span>
									</template>
								</b-table>
								<div class="d-flex justify-content-between px-3 pb-3">
									<b-pagination class="mt-1" @change="navigatePage" v-model="currentPage"
										:total-rows="totalRecords" :per-page="perPage"
										aria-controls="member-table"></b-pagination>
									<div class="col text-end mt-1 akkurate-dark">
										<div>
											{{ currentPage }} - {{ perPage }} of
											{{ totalRecords }}
										</div>
										<b-form-group label="Per Page" label-size="sm" class="mb-0">
											<b-form-select @change="selectPerPage" id="per-page-select"
												v-model="perPage" :options="per_page_options" size="sm"></b-form-select>
										</b-form-group>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<Footer></Footer>
			<b-modal size="lg" id="bv-modal-loan-trans-edit" hide-footer>
				<template #modal-title>
					<h6 class="m-0 fw-bold text-green text-sm">
						Edit Loan Transaction
					</h6>
				</template>
				<edit-transaction :trans_data="trans_data" @savedEdit="savedEdit"></edit-transaction>
			</b-modal>
			<b-modal size="lg" id="bv-modal-saving-trans" hide-footer>
				<template #modal-title>
					<h6 class="m-0 fw-bold text-green text-sm">
						Transfer To Savings
					</h6>
				</template>
				<transfer-savings :trans_data="trans_data" @savedEdit="savedEdit"></transfer-savings>
			</b-modal>
			<b-modal size="lg" id="bv-modal-transfer-loan-transaction" hide-footer>
				<template #modal-title>
					<h6 class="m-0 fw-bold text-green text-sm">
						Transfer Loan Transaction
					</h6>
				</template>
				<transfer-loan-transaction :transaction_id="transaction_id"
					@loanTransfered="loanTransfered"></transfer-loan-transaction>
			</b-modal>
		</div>

		<!-- AI -->
		 <ChatBot />
		<!-- End AI -->
		<a class="d-inline scroll-to-top" href="#page-top"><i class="fas fa-angle-up"></i></a>
		<cash-repayment ref="showCashRepayment" :report_data="report_data"></cash-repayment>
		<cash-disbursement ref="showCashDisbursement" :report_data="report_data"></cash-disbursement>
		<setoff-disbursement ref="showSetoffDisbursement" :report_data="report_data"></setoff-disbursement>
		<setoff-repayment ref="showSetOffRepayment" :report_data="report_data"></setoff-repayment>
	</div>
</template>
<script>
import SidebarView from "@/views/main/components/Sidebar.vue";
import TopbarView from "@/views/main/components/Topbar.vue";
import Footer from "@/views/main/components/Footer.vue";
import ApiService from "@/core/services/api.service";
import ExcelJS from 'exceljs';
import Multiselect from "vue-multiselect";
import LoanTransFilter from "./form/LoanTransFilter.vue";
import { hasPermission } from "@/helper";
import LoanTransactionView from "./view/LoanTransactionView.vue";
import EditTransaction from "./form/EditTransaction.vue";
import TransferSavings from "./form/TransferSavings.vue";
import TransferLoanTransaction from "./form/TransferLoanTransaction.vue";
import CashRepayment from "../reports/cash/CashRepayment.vue";
import CashDisbursement from "../reports/cash/CashDisbursement.vue";
import SetoffRepayment from "../reports/set-off/SetoffRepayment.vue";
import SetoffDisbursement from "../reports/set-off/SetoffDisbursement.vue";
import ChatBot from "@/views/components/AI/ChatBot.vue";
export default {
	components: {
		SidebarView,
		TopbarView,
		Footer,
		Multiselect,
		LoanTransFilter,
		LoanTransactionView,
		EditTransaction,
		TransferSavings,
		TransferLoanTransaction,
		CashRepayment,
		CashDisbursement,
		SetoffRepayment,
		SetoffDisbursement,
		ChatBot,
	},
	data() {
		return {
			...this.initialState(),
			trans_data: {},
			report_data: {},
			trans_columns: [
				{
					label: "Loan_No",
					key: "loan_number",
				},
				{
					label: "References",
					key: "references",
				},
				{
					label: "(Ext)Reference",
					key: "loan.external_reference",
				},
				{
					label: "Loan_Product",
					key: "loan.loan_product.name",
				},

				{
					label: "Borrowers_Name",
					key: "full_name",
				},
				{
					label: "Type",
					key: "transaction_type",
				},
				{
					label: "Mode",
					key: "transaction_mode",
				},
				{
					label: "Loan_Disbursed",
					key: "loan_principal_amount",
				},
				{
					label: "Expected_Interest",
					key: "loan_expected_interest",
				},
				{
					label: "Total_Amount",
					key: "trans_amount",
				},
				{
					label: "Principal_Paid",
					key: "principal",
				},
				{
					label: "Total_Principal_Paid",
					key: "principal_paid",
				},
				{
					label: "Interest_Paid",
					key: "interest",
				},
				{
					label: "Total_Interest_Paid",
					key: "interest_paid",
				},
				{
					label: "Principal_Bal",
					key: "principal_balance",
				},
				{
					label: "Interest_Bal",
					key: "interest_balance",
				},
				{
					label: "Date",
					key: "trans_date",
				},
				{
					label: "Branch",
					key: "account.branch.name",
				},
				{
					label: "Status",
					key: "trans_status",
				},

				{
					label: "Actions",
					key: "actions",
				},
			],
			rows: [],
			currentPage: 1,
			perPage: 10,
			per_page_options: ["10", "20", "50", "100", "500", "All"],
			restore_trans: false,
			transfer_saving: false,
			transaction_id: "",
		};
	},
	mounted() {
		this.getAccountDropdown();
		this.getInsistution();
		this.loadTransactions();
		this.checkPemission();
	},
	methods: {
		showLoanTransEditModal(row) {
			this.trans_data = row;
			this.$bvModal.show("bv-modal-loan-trans-edit");
		},
		showSavingTransfertModal(row) {
			this.trans_data = row;
			this.$bvModal.show("bv-modal-saving-trans");
		},
		savedEdit() {
			this.loadTransactions();
			this.$bvModal.hide("bv-modal-loan-trans-edit");
		},
		statusBadge(item) {
			if (item === "COMPLETED") {
				return "badge akkurate-green-bg";
			} else if (item === "FAILED") {
				return "badge akkurate-danger-bg";
			} else if (item === "REVERSED") {
				return "badge akkurate-danger-bg";
			} else if (item === "PENDING") {
				return "badge akkurate-warning-bg";
			} else {
				return "badge akkurate-warning-bg";
			}
		},
		checkPemission() {
			// console.log(hasPermission())
			// this.reverse_pemission = hasPermission('transaction_management_deposit_withdrawal_reversal')
			this.delete_trans = hasPermission(
				"transaction_management_delete"
			);
			this.restore_trans = hasPermission(
				"transaction_management_restore"
			);
			this.transfer_saving = hasPermission(
				"transaction_management_transfer"
			);
		},
		submitFormFilters() {
			this.loadTransactions();
		},
		rowClass() {
			return "custom-row-height";
		},
		filterTable() {
			this.loadTransactions();
		},

		navigatePage(index) {
			this.isLoading = true;
			this.currentPage = index;
			this.loadTransactions();
		},
		selectPerPage(index) {
			this.perPage = index;
			this.loadTransactions();
		},
		handleOk(bvModalEvent) {
			// Prevent modal from closing
			// bvModalEvent.preventDefault();
			// Trigger submit handler
			this.submitFormFilters();
		},
		async getAccountDropdown() {
			await ApiService.get("/loans/paginate/dropdown")
				.then((response) => {
					// console.log(response);
					this.branch_option = response.data.branches;
					this.schemes_option = response.data.schemes;
				})
				.catch((error) => {
					// console.log(error);
				});
		},
		async getInsistution() {
			await ApiService.get("/settings/institution")
				.then((response) => {
					// console.log(response);
					this.institution = response.data.data;
				})
				.catch((error) => {
					// console.log(error);
				});
		},
		async loadTransactions(searchFilter = null) {
			this.isLoading = true;
			var branch_id = "";
			var acc_id = "";
			var scheme_id = "";
			if (this.form.branch != null) {
				branch_id = this.form.branch.id;
			}
			if (this.form.acc_types != null) {
				acc_id = this.form.acc_types.id;
			}
			if (this.form.scheme != null) {
				scheme_id = this.form.scheme.id;
			}

			this.$Progress.start();
			this.isLoading = true;
			let source = "";
			if (this.form?.trans_source?.value === "ussd" || this.form?.trans_source?.value === "web" || this.form?.trans_source?.value === "mobile") {
				source = this.form?.trans_source.value;
			}
			if (this.perPage === 'All') {
				this.perPage = this.totalRecords;
			}
			await ApiService.post("/loans/transactions/all", {
				"page": this.currentPage,
				"per_page": this.perPage,
				filter: this.form.search,
				branch_id: branch_id,
				account_type_id: acc_id,
				// account_number: ac,
				// mobile: phone,
				start_date: this.form.start_date,
				end_date: this.form.end_date,
				status: this.form.status,
				// code: code,
				transaction_type: this.form.transaction_type,
				external_reference: this.form.external_reference,
				source: source,
				users: this.form.users,
				scheme: scheme_id,
				term: this.form.term,
				transaction_mode: this.form.transaction_mode,
				gender: this.form.gender,
				loan_status: this.form.loan_status,
				loan_number: this.form.loan_number,
			}).then((response) => {
				// console.log(response.data.data);
				this.rows = response.data.data;
				this.total_loan_disbursed = response.data.total_loan_disbursed
				this.total_loan_repayment = response.data.total_loan_repayment
				this.total_loan_principal_balance = response.data.total_loan_principal_balance
				this.total_loan_interest_balance = response.data.total_loan_interest_balance
				this.total_loan_balance = response.data.total_loan_balance
				this.totalRecords = response.data.meta.total;
				this.total_principal_paid = response.data.total_principal_paid
				this.total_interest_paid = response.data.total_interest_paid
				this.total_expected_interest = response.data.total_expected_interest
				this.total_adjustment_repayment = response.data.total_adjustment_repayment;
				this.total_actual_disbursed = response.data.total_actual_disbursed;
				// this.all_data = response.data.data;
				this.$Progress.finish();
			})
				.catch((error) => {
					// console.log(error);
					this.isLoading = false;
					this.$Progress.fail();
				})
				.finally(() => {
					this.isLoading = false;
					this.$Progress.finish();
				});
		},

		initialState() {
			return {
				totalRecords: 0,
				showViewTransaction: false,
				searchFilter: "",
				total_loan_disbursed: "",
				total_loan_repayment: "",
				total_loan_principal_balance: "",
				total_loan_interest_balance: "",
				total_loan_balance: "",
				total_adjustment_repayment: "",
				total_actual_disbursed: "",
				coa_name: "",
				form: {
					branch: "",
					acc_types: "",

					start_date: "",
					end_date: "",
					status: "",
					// code: { name: "Customer code", value: "filter" },
					external_reference: "",
					users: [],
					status_option: ["Active", "Inactive", "Dormant", "Closed"],
					search: "",
					trans_source: { name: '', value: "" },
					transaction_type: "",
					scheme: [],
					term: "",
					gender: "",
					loan_status: "",
				},
				branch_option: [],
				schemes_option: [],
				isLoading: true,
				isSaving: false,
				add_or_edit: "add",
				report_data: {},
				institution: {},
				users: [],
				total_principal_paid: "",
				total_expected_interest: "",
				total_interest_paid: "",
			};
		},

		reverseTransaction(trans) {
			swal.fire({
				title: "Reverse Transaction",
				text: `Are you sure you want to reverse transaction ${trans.code}?`,
				icon: "warning",
				showCancelButton: true,
				confirmButtonText: "Yes",
				cancelButtonText: "No",
				allowOutsideClick: true,
				customClass: {
					confirmButton:
						"btn btn-size akkurate-green-btn modal-btn-width text-white me-2", // Custom class for the "OK" button
					cancelButton:
						"btn btn-size akkurate-danger-btn modal-btn-width text-white", // Custom class for the custom button
				},
			}).then((result) => {
				if (result.value) {
					//   window.location.reload();
					let url = "/transactions/deposits/reverse";
					if (trans.transaction_type == "Deposit") {
						url = "/transactions/deposits/reverse";
					} else if (trans.transaction_type == "Withdrawal") {
						url = "/transactions/withdrawals/reverse";
					}

					this.$Progress.start();
					ApiService.post(url, {
						code: trans.code,
						source: "OFFICE",
					})
						.then((respp) => {
							// console.log(respp);
							//this.isLoading = false;
							this.$Progress.finish();
							toast.fire({
								icon: "success",
								title: respp.data.message,
							});

							this.loadTransactions();
						})
						.catch((error) => {
							this.$Progress.fail();
						});
				}
			});
		},

		viewTransaction(trans) {
			// console.log("Veeeew");
			this.showViewTransaction = true;
		},
		// getFullname(trans) {
		//   return `${trans.customer?.first_name} ${trans.customer?.last_name}`;
		// },
		getCreatedAt(trans) {
			return this.removeAfterDot(trans.created_at);
		},
		approveWithdrawal(trans) {
			console.log(trans);
			swal.fire({
				title: "Approve Withdrawal!",
				// title: "Successfull Saved",
				text: `Are you sure you want to approve withdrawal transaction ${trans.code}?`,
				// text: 'CODE : 14345664565',
				confirmButtonColor: "#018673",
				icon: "info",
				allowOutsideClick: false,
				allowEscapeKey: false,
				showCancelButton: true, // Show the "Cancel" button
				confirmButtonText: "Yes", // Customize the text for the "OK" button
				cancelButtonText: "No", // Text for the custom button
				buttonsStyling: false, // Disable SweetAlert2 styling for buttons
				customClass: {
					confirmButton:
						"btn btn-size akkurate-green-btn modal-btn-width text-white me-2", // Custom class for the "OK" button
					cancelButton:
						"btn btn-size akkurate-ash modal-btn-width text-white", // Custom class for the custom button
				},
			}).then(async (result) => {
				if (result.isConfirmed) {
					await ApiService.post(
						"/transactions/withdrawals/approve",
						{
							transaction_id: trans.id,
							code: trans.code,
						}
					)
						.then((respp) => {
							toast.fire({
								icon: "success",
								title: respp.data.message,
							});

							this.loadTransactions();
						})
						.catch((error) => {
							if (error.response.data.message) {
								toast.fire({
									icon: "error",
									title: error.response.data.message,
								});
							} else {
								toast.fire({
									icon: "error",
									title: "An error occurred",
								});
							}
						})
						.finally((resp) => {
							this.isLoading = false;
						});
				} else if (result.isDismissed) {
				}
			});
		},
		removeAfterDot(inputString) {
			if (inputString.includes(".")) {
				return inputString.split(".")[0];
			}
			return inputString; // If there's no dot, return the original string
		},
		async exportToExcel() {
			const fileUrl = "/REPORT_TEMPLATE_NEW.xlsx"; // Path to the file in the public folder
			const imageUrl = "/default_logo.png"; // Path to your image file

			// Institution details
			const institutionName = this.institution.name;
			const institutionMotto = this.institution.motto;
			const institutionAddress = this.institution.address;
			const institutionPhone = this.institution.telephone;
			const institutionEmail = this.institution.email;

			try {
				// Fetch the Excel file from the public URL
				const response = await fetch(fileUrl);
				if (!response.ok) {
					throw new Error(
						`Network response was not ok: ${response.statusText}`
					);
				}
				const arrayBuffer = await response.arrayBuffer();

				// Load the file into ExcelJS
				const wb = new ExcelJS.Workbook();
				await wb.xlsx.load(arrayBuffer);

				// Access the first sheet
				const ws = wb.getWorksheet(1); // Get the first worksheet

				// Add Image to the top of the sheet
				const imageResponse = await fetch(imageUrl);
				const imageBuffer = await imageResponse.arrayBuffer();
				const imageId = wb.addImage({
					buffer: imageBuffer,
					extension: "png", // Adjust this if you're using a different image type (e.g., jpg)
				});

				// Insert the image at the top-left corner (row 1, column 1)
				ws.addImage(imageId, {
					tl: { col: 0, row: 0 }, // Top-left corner (adjust this as needed)
					ext: { width: 300, height: 200 }, // Set the image size (adjust width/height as needed)
				});

				// Insert institution details next to the image (starting at row 1, col 5)
				const institutionDetailsStartCol = 5; // Column where text starts after image
				const institutionDetailsRow = 1; // Row for institution details

				// Add the institution name, address, and phone number
				ws.getCell(`T${institutionDetailsRow}`).value = institutionName;
				ws.getCell(`T${institutionDetailsRow}`).font = { bold: true, size: 14 }; // Bold and bigger font for name

				ws.getCell(`T${institutionDetailsRow + 1}`).value = institutionAddress;
				ws.getCell(`T${institutionDetailsRow + 1}`).font = { size: 12 };  // Regular font size for address

				ws.getCell(`T${institutionDetailsRow + 2}`).value = institutionMotto;
				ws.getCell(`T${institutionDetailsRow + 2}`).font = { size: 12 };  // Regular font size for phone

				ws.getCell(`T${institutionDetailsRow + 3}`).value = institutionPhone;
				ws.getCell(`T${institutionDetailsRow + 3}`).font = { size: 12 };  // Regular font size for phone

				ws.getCell(`T${institutionDetailsRow + 4}`).value = institutionEmail;
				ws.getCell(`T${institutionDetailsRow + 4}`).font = { size: 12 };  // Regular font size for phone

				// Optionally adjust the column width if the text is long
				ws.getColumn('U').width = 50;  // Adjust the width of column D (if necessary)

				// Define header row
				const header = [
					"Loan Number",
					"References",
					"Full name",
					"Amount",
					"Principal Paid",
					"Interest Paid",
					"Total Principal Paid",
					"Total Interest Paid",
					"Principal Balance",
					"Interest Balance",
					"Account Number",
					"Transaction type",
					"Transaction mode",
					"Phone Number",
					"Status",
					"Date",
					"Source",
					"Users",
					"Product",
					"Old Code",
					"New Code"
				];



				// Add header row starting from row 13 (or the next row after the image and details)
				const startingRow = institutionDetailsRow + 10; // Row 4 after institution details
				let headerRow = ws.getRow(startingRow);
				headerRow.values = header;
				headerRow.font = { bold: true };
				headerRow.commit(); // Commit the row to the worksheet

				// Add individual data rows
				let currentRow = startingRow + 1;

				// Process each item
				this.rows.forEach(item => {
					const row = ws.getRow(currentRow);
					// Map item values to the corresponding header columns
					row.values = [
						item.loan.loan_number,
						this.getRef(item),
						item.customer?.first_name + ' ' + item.customer?.last_name,
						item.trans_amount,
						item.principal,
						item.interest,
						item.principal_paid,
						item.interest_paid,
						item.principal_balance,
						item.interest_balance,
						item.account.account_number, // Remove extra spaces
						item.transaction_type,
						item.transaction_mode,
						item.customer.mobile,
						item.trans_status,
						item.trans_date,
						item.source,
						item.created_by_user?.first_name + ' ' + item.created_by_user?.surname,
						item.loan?.loan_product?.name,
						item.customer.external_code,
						item.customer.code
					];
					row.commit();
					currentRow++;
				});
				const buffer = await wb.xlsx.writeBuffer();
				const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

				// Create a download link and simulate a click to download the file
				const link = document.createElement("a");
				link.href = URL.createObjectURL(blob);
				link.download = "Excel_Transactions.xlsx";
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
			} catch (err) {
				console.error(
					"Error fetching, modifying, or downloading the Excel file:",
					err.message
				);
			}
		},
		rejectWithdrawal(data) {
			swal.fire(
				{
					title: "Confirm Withdrawal Rejection",
					// text: 'CODE : ' + response.data.transaction.code,
					text: "Are you sure you want to reject this withdrawal?",
					confirmButtonColor: "#018673",
					icon: "question",
					type: "input",
					allowOutsideClick: false,
					allowEscapeKey: false,
					showCancelButton: true, // Show the "Cancel" button
					confirmButtonText: "Yes", // Customize the text for the "OK" button
					cancelButtonText: "No", // Text for the custom button
					buttonsStyling: false, // Disable SweetAlert2 styling for buttons
					customClass: {
						confirmButton:
							"btn btn-size btn-danger modal-btn-width text-white me-2", // Custom class for the "OK" button
						cancelButton:
							"btn btn-size akkurate-ash modal-btn-width text-white", // Custom class for the custom button
					},
				},
				function (inputValue) {
					if (inputValue === null) return false;

					if (inputValue === "") {
						// swal.showInputError("You need to write something!");
						return false;
					}

					// swal("Nice!", "You wrote: " + inputValue, "success");
				}
			).then((result) => {
				// this.$Progress.start();
				if (result.isConfirmed) {
					this.isLoading = true;
					// this.getAccountStatement();
					// // this.isLoading = false;
					// this.$Progress.finish();

					this.loadTransactions();
					// this.$bvModal.hide(String(this.loan_no + this.statement));
				} else if (result.isDismissed) {
					this.isLoading = false;
					// this.$Progress.finish();
				}
			});
		},
		fullName({ first_name, surname, code }) {
			let name = "";
			if (first_name) {
				name = name + first_name;
			}

			if (surname) {
				name = name + " " + surname;
			}

			//   if(code)
			//   {
			//     name = name + ` (${code})`;
			//   }

			return `${name}`;
		},
		limitText(count) {
			return `and ${count} other user(s)`;
		},
		deleteTransaction(index) {
			swal.fire(
				{
					title: "Delete Transactions",
					// text: 'CODE : ' + response.data.transaction.code,
					text: "Are you sure you want to delete this Transaction?",
					confirmButtonColor: "#018673",
					icon: "question",
					type: "input",
					allowOutsideClick: false,
					allowEscapeKey: false,
					showCancelButton: true, // Show the "Cancel" button
					confirmButtonText: "Yes", // Customize the text for the "OK" button
					cancelButtonText: "No", // Text for the custom button
					buttonsStyling: false, // Disable SweetAlert2 styling for buttons
					customClass: {
						confirmButton:
							"btn btn-size btn-danger modal-btn-width text-white me-2", // Custom class for the "OK" button
						cancelButton:
							"btn btn-size akkurate-ash modal-btn-width text-white", // Custom class for the custom button
					},
				},
				function (inputValue) {
					if (inputValue === null) return false;

					if (inputValue === "") {
						// swal.showInputError("You need to write something!");
						return false;
					}

					// swal("Nice!", "You wrote: " + inputValue, "success");
				}
			).then(async (result) => {
				// this.$Progress.start();
				if (result.isConfirmed) {
					this.isLoading = true;
					await ApiService.delete(
						`/transactions/transaction/${index.id}`
					)
						.then((respp) => {
							toast.fire({
								icon: "success",
								title: respp.data.message,
							});

							this.loadTransactions();
						})
						.catch((error) => {
							if (error.response.data.message) {
								toast.fire({
									icon: "error",
									title: error.response.data.message,
								});
							} else {
								toast.fire({
									icon: "error",
									title: "An error occurred",
								});
							}
						})
						.finally((resp) => {
							this.isLoading = false;
						});

					this.loadTransactions();
					// this.$bvModal.hide(String(this.loan_no + this.statement));
				} else if (result.isDismissed) {
					this.isLoading = false;
					// this.$Progress.finish();
				}
			});
		},
		restoreTransaction(data) {
			swal.fire({
				title: "Please confirm",
				html: `Are you sure you want to <strong>RESTORE</strong> Transaction - <strong>${data.id}</strong>`,
				icon: "info",
				allowOutsideClick: true,
				allowEscapeKey: true,
				showCancelButton: true, // Show the "Cancel" button
				confirmButtonText: 'Restore', // Customize the text for the "OK" button
				cancelButtonText: 'No', // Text for the custom button
				buttonsStyling: false, // Disable SweetAlert2 styling for buttons
				customClass: {
					confirmButton: 'btn akkurate-green-btn modal-btn-width text-white me-2', // Custom class for the "OK" button
					cancelButton: 'btn akkurate-gray-btn modal-btn-width text-white' // Custom class for the custom button
				}
			}).then(async result => {
				if (result.isConfirmed) {
					this.$Progress.start();
					await ApiService.post(`/transactions/transaction/${data.id}/restore`).then((response) => {
						this.$Progress.finish();
						swal.fire({
							// title: response.statusText,
							text: response.data.message,
							icon: "success",
							allowOutsideClick: true,
							allowEscapeKey: true,
							showCancelButton: false, // Show the "Cancel" button
							confirmButtonText: 'okay', // Customize the text for the "OK" button
							buttonsStyling: false, // Disable SweetAlert2 styling for buttons
							customClass: {
								confirmButton: 'btn akkurate-green-btn modal-btn-width text-white me-2', // Custom class for the "OK" button
							}
						});
						this.loadTransactions();
					}).catch((error) => {
						this.$Progress.fail();
						swal.fire({
							// title: response.statusText,
							text: error.response.data.message,
							icon: "error",
							allowOutsideClick: true,
							allowEscapeKey: true,
							showCancelButton: false, // Show the "Cancel" button
							confirmButtonText: 'okay', // Customize the text for the "OK" button
							buttonsStyling: false, // Disable SweetAlert2 styling for buttons
							customClass: {
								confirmButton: 'btn akkurate-green-btn modal-btn-width text-white me-2', // Custom class for the "OK" button
							}
						});

					})
					//
				}
			});
		},
		getRef(data) {
			if (data.transaction_mode == 'Adjustment') {
				return 'TRA' + data?.id
			}
			if (data.transaction_type == 'Loan Disbursed') {
				return 'LOA' + data.loan?.id
			} else {
				return 'TRA' + data?.id
			}
		},
		transferModal(transaction_id) {
			this.transaction_id = transaction_id;
			this.$bvModal.show("bv-modal-transfer-loan-transaction");
		},
		loanTransfered() {
			this.loadTransactions();
		},
		printOut(data) {
			this.report_data = {
				'institution': this.institution,
				'branch_name': data.account?.branch?.name,
				'receipt_no': data.id,
				'loan_number': data.loan?.loan_number,
				'trans_date': data.trans_date,
				'teller': data.created_by_user?.first_name + ' ' + data.created_by_user?.surname,
				'account_number': data.account?.account_number,
				'fullname': (data.customer?.first_name ?? '') + ' ' + (data.customer?.middlename ?? '') + ' ' + (data.customer?.last_name ?? ''),
				'transaction_mode': data.transaction_mode,
				'transaction_type': data.transaction_type,
				'amount': data.trans_amount,
			};
			if (data.transaction_type == 'Loan Repayment') {
				switch (data.transaction_mode) {
					case 'Cash':
						this.$refs.showCashRepayment.showModal();
						break;
					case 'Set-Off':
						this.$refs.showSetOffRepayment.showModal();
						break;
					// case 'Bank Transfer':
					//   this.$refs.showBankTransferRepayment.showModal();
					//   break;
					// case 'Cheque':
					//   this.$refs.showChequeRepayment.showModal();
					//   break;
					default:
						this.$refs.showCashRepayment.showModal();
				}
			} else if (data.transaction_type == 'Loan Disbursed') {
				switch (data.transaction_mode) {
					case 'Cash':
						this.$refs.showCashDisbursement.showModal();
						break;
					case 'Set-off':
						this.$refs.showSetoffDisbursement.showModal();
						break;
					// case 'Bank Transfer':
					//   this.$refs.showBankTransferRepayment.showModal();
					//   break;
					// case 'Cheque':
					//   this.$refs.showChequeRepayment.showModal();
					//   break;
					default:
						this.$refs.showCashRepayment.showModal();
				}
			} else if (data.transaction_type == 'Disbursement') {
			}

		}

	},
	computed: {
		//   total_difference() {
		//     return (this.total_complete_deposits - this.total_complete_withdrawals)
		//   }
	}
};
</script>
